import React from 'react';

type StickyHeaderContextValue = {
  headerSubtitle: string | null;
  setHeaderSubtitle: (subtitle: string | null) => void;
};

const StickyHeaderContext = React.createContext<StickyHeaderContextValue>({
  headerSubtitle: null,
  setHeaderSubtitle: () => {},
});

export function StickyHeaderProvider({children}: {children: React.ReactNode}) {
  const [headerSubtitle, setHeaderSubtitle] = React.useState<string | null>(null);

  const value = React.useMemo(() => ({headerSubtitle, setHeaderSubtitle}), [headerSubtitle]);

  return <StickyHeaderContext.Provider value={value}>{children}</StickyHeaderContext.Provider>;
}

export function useStickyHeader() {
  return React.useContext(StickyHeaderContext);
}
